import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import Breadcrumb from './Breadcrumb';
import { apiRoutes } from '../../AppSettings';
import { AuthContext } from '../../contexts/AuthContext';
import logo from '../../assets/img/logo.png'

const InvoiceView = (props) => {

    const invoiceId = props.location.state.invoiceId;
    const { userState } = useContext(AuthContext);

    const discount = 10;
    const vat = 0;
    const [invoice, setInvoice] = useState({});
    const [doctor, setDoctor] = useState({});
    const [patient, setPatient] = useState({});

    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
    };
    
    useEffect(() => {
        axios.get(apiRoutes.getInvoiceById + invoiceId, options)
            .then((response) => {
                if(response.status === 200) {
                    console.log(response.data)
                    setInvoice(response.data);
                    setDoctor(response.data.appoinment.doctor);
                    setPatient(response.data.appoinment.patient);
                }   
            }, (error) => {
                console.log(error);
            });

    }, []);


    return ( 
        <div>
            <Breadcrumb title="Invoice View" />
            <div className="content">
				<div className="container-fluid">
					<div className="row">
						<div className="col-lg-8 offset-lg-2">
							<div className="invoice-content">
								<div className="invoice-item">
									<div className="row">
										<div className="col-md-6">
											<div className="invoice-logo">
												<img src={logo} alt="logo" />
											</div>
										</div>
										<div className="col-md-6">
											<p className="invoice-details">
                                                <strong>Order:</strong> #{invoice.invoiceNumber} <br />
												<strong>Issued:</strong> {(new Date(invoice.createdDate).toLocaleDateString())}
											</p>
										</div>
									</div>
								</div>
								<div className="invoice-item">
									<div className="row">
										<div className="col-md-6">
											<div className="invoice-info">
												<strong className="customer-text">Invoice From</strong>
												<p className="invoice-details invoice-details-two">
                                                    Dr. {doctor.firstName} {doctor.lastName} <br />
                                                    {doctor.addressLine1}, {doctor.addressLine2} {doctor.city} <br />
													{doctor.state}, {doctor.country} <br />
												</p>
											</div>
										</div>
										<div className="col-md-6">
											<div className="invoice-info invoice-info2">
												<strong className="customer-text">Invoice To</strong>
												<p className="invoice-details">
                                                    {patient.firstName} {patient.lastName} <br />
                                                    {patient.address}, {patient.city} <br />
													{patient.state}, {patient.zipCode}, {patient.country} <br />
												</p>
											</div>
										</div>
									</div>
								</div>
								<div className="invoice-item">
									<div className="row">
										<div className="col-md-12">
											<div className="invoice-info">
												<strong className="customer-text">Payment Method</strong>
												<p className="invoice-details invoice-details-two">
													Debit Card <br />
													XXXXXXXXXXXX-2541 <br />
													HDFC Bank<br />
												</p>
											</div>
										</div>
									</div>
								</div>
								<div className="invoice-item invoice-table-wrap">
									<div className="row">
										<div className="col-md-12">
											<div className="table-responsive">
												<table className="invoice-table table table-bordered">
													<thead>
														<tr>
															<th>Description</th>
															<th className="text-center">Quantity</th>
															<th className="text-center">VAT</th>
															<th className="text-right">Total</th>
														</tr>
													</thead>
													<tbody>
                                                        {   
                                                            invoice.invoiceItems != undefined &&
                                                            invoice.invoiceItems.map(item => (
                                                                <tr key={item.invoiceItemId}>
                                                                    <td>{item.description}</td>
                                                                    <td className="text-center">{item.quantity}</td>
                                                                    <td className="text-center">${vat}</td>
                                                                    <td className="text-right">${item.amount}</td>
                                                                </tr>
                                                            ))
                                                        }
													</tbody>
												</table>
											</div>
										</div>
										<div className="col-md-6 col-xl-4 ml-auto">
											<div className="table-responsive">
												<table className="invoice-table-two table">
													<tbody>
													<tr>
														<th>Subtotal:</th>
                                                        <td><span>${invoice.totalAmount}</span></td>
													</tr>
													<tr>
														<th>Discount:</th>
                                                        <td><span>-{discount}%</span></td>
													</tr>
													<tr>
														<th>Total Amount:</th>
                                                        <td><span>${invoice.totalAmount - (invoice.totalAmount/discount)}</span></td>
													</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>		
        </div>
    );
}
 
export default InvoiceView;